import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NpsOverallComponent} from './nps-overall.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [NpsOverallComponent],
  imports: [
    CommonModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [NpsOverallComponent]
})
export class NpsOverallModule {
}
